import React, { useState, useEffect, useMemo } from "react";
import Modal from "../Modal";
import SearchableDropdown from "../SearchableDropdown";

function TicketAddBackupModal({
  isOpen,
  onClose,
  onSubmit,
  title = "Please select backup user:",
  userList = [],
  currentUserEmail,
  currentBackupEmail,     // optional (prefill)
}) {
  const [selectedEmail, setSelectedEmail] = useState("");

  useEffect(() => {
    if (isOpen) {
      setSelectedEmail(currentBackupEmail || "");
    }
  }, [isOpen, currentBackupEmail]);

  const options = useMemo(
    () => userList.filter(u => u.email !== currentUserEmail),
    [userList, currentUserEmail]
  );

  const isSubmitDisabled = !selectedEmail;

  const handleSubmit = () => {
    onSubmit(selectedEmail);
    setSelectedEmail("");
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-4">
        <h4 className="mb-3">{title}</h4>

        <div className="mb-3">
          <label className="form-label">Select backup user:</label>
          <SearchableDropdown
            id="backup-user-dd"
            options={options}
            selectedValue={selectedEmail}
            onSelectedChange={setSelectedEmail}
            placeholder="Select user"
          />
        </div>

        <div className="d-flex justify-content-end">
          <button className="btn btn-secondary me-2" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          >
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default TicketAddBackupModal;
